import SurveyDetails from './SurveyDetailsContainer';

export default SurveyDetails;
